import React from "react";
import "./HomeStyle.scss";
import Sidebar from "../../components/general/sidebar/Sidebar";
import videoBg from "../../assets/Movie/videoBg.mp4";

const Home = () => {
  return (
    <main id="page-home">
      <Sidebar />
      <section className="hero">
        <div className="title" id="frase">
          <h1>Monitoramento</h1>
        </div>

        <video className="video_bg" loop muted autoPlay controls="">
          <source src={videoBg} type="video/webm" />
          <source src={videoBg} type="video/mp4" />
        </video>
      </section>
    </main>
  );
};
export default Home;
